var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorsNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 129,
    viewBox: "0 0 67 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39622 125.835C0.786626 126.445 0.786626 127.433 1.39622 128.043C2.00582 128.652 2.99418 128.652 3.60378 128.043L66.0428 65.6038C66.6524 64.9942 66.6524 64.0058 66.0428 63.3962L3.60378 0.957199C2.99418 0.3476 2.00582 0.3476 1.39622 0.957199C0.786626 1.5668 0.786626 2.55516 1.39622 3.16475L62.7537 64.5L1.39622 125.835Z",
    fill: "#FB5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsNext);
export default __webpack_public_path__ + "static/media/doctors__next.82dd084233cc4abcbdaad9a0080ccbb9.svg";
export { ForwardRef as ReactComponent };